// ── Helpers d'affichage pour les sites/boutiques (tenants) ──────────

/**
 * Analyse une chaîne potentiellement en HTML et renvoie un texte lisible
 * (balises retirées, entités décodées, espaces normalisés).
 */
export function htmlToText(input?: string | null): string {
  if (!input) return '';
  let text = String(input);

  // Retirer les blocs script / style
  text = text.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, ' ');
  // Les sauts de ligne et fins de blocs deviennent des espaces
  text = text.replace(/<br\s*\/?>/gi, ' ');
  text = text.replace(/<\/(p|div|h[1-6]|li|section|article|tr)>/gi, ' ');
  // Retirer toutes les balises restantes
  text = text.replace(/<[^>]+>/g, '');
  // Décoder les entités HTML les plus courantes
  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&apos;/gi, "'");

  // Normaliser les espaces
  return text.replace(/\s+/g, ' ').trim();
}

/**
 * Résout le nom affiché de la boutique.
 *
 * Note : le champ `navTitle` du thème contient parfois la description du menu
 * (ex. « Accueil | Services | À propos | Contact ») et non le nom du commerce.
 * On l'utilise donc uniquement s'il ressemble à un vrai nom (sans séparateur
 * de liens), sinon on retombe sur le nom du commerce.
 */
export function resolveStoreName(
  tenant?: { nomcommerce?: string | null; name?: string | null } | null,
  theme?: { navTitle?: string | null } | null,
): string {
  const fallback = (tenant?.nomcommerce || tenant?.name || 'Boutique').trim();
  const navTitle = (theme?.navTitle || '').trim();
  const looksLikeNav = navTitle.includes('|') || navTitle.includes('>');
  if (navTitle && !looksLikeNav) return navTitle;
  return fallback;
}